import { render } from "./TourSimple.vue?vue&type=template&id=02a767cb&scoped=true"
import script from "./TourSimple.vue?vue&type=script&lang=js"
export * from "./TourSimple.vue?vue&type=script&lang=js"

import "./TourSimple.vue?vue&type=style&index=0&id=02a767cb&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a767cb"]])

export default __exports__